export const CIRCLE_MOCK_DATA = {
  name: '',
  children: [
    {
      name: 'node.0',
      value: 96,
    },
    {
      name: 'node.1',
      value: 100,
    },
    {
      name: 'node.2',
      value: 60,
    },
    {
      name: 'node.3',
      value: 43,
    },
    {
      name: 'node.4',
      value: 74,
    },
    {
      name: 'node.5',
      value: 35,
    },
    {
      name: 'node.6',
      value: 45,
    },
    {
      name: 'node.7',
      value: 48,
    },
    {
      name: 'node.8',
      value: 63,
    },
    {
      name: 'node.9',
      value: 61,
    },
    {
      name: 'node.10',
      value: 39,
    },
    {
      name: 'node.11',
      value: 88,
    },
    {
      name: 'node.12',
      value: 83,
    },
    {
      name: 'node.13',
      value: 32,
    },
    {
      name: 'node.14',
      value: 78,
    },
    {
      name: 'node.15',
      value: 45,
    },
    {
      name: 'node.75',
      value: 38,
    },
    {
      name: 'node.17',
      value: 58,
    },
    {
      name: 'node.18',
      value: 82,
    },
    {
      name: 'node.19',
      value: 88,
    },
    {
      name: 'node.20',
      value: 45,
    },
    {
      name: 'node.21',
      value: 81,
    },
    {
      name: 'node.22',
      value: 70,
    },
    {
      name: 'node.23',
      value: 53,
    },
    {
      name: 'node.24',
      value: 67,
    },
    {
      name: 'node.25',
      value: 76,
    },
  ],
}
